/**
 * Single source of truth for the API host the app talks to.
 *
 * The Sweet Spot is a frontend-only app (this repo). It talks to the shared
 * Ampersand API platform (AmpersandBrands/api repo) over HTTPS, the same
 * platform Cockpit uses, at VITE_API_BASE (default the dev host below).
 *
 * `VITE_API_BASE` overrides at build or dev-server time (set it to '' in
 * `.env.local` for local dev so paths stay same-origin and the Vite proxy in
 * vite.config.ts forwards `/api` to a local runner).
 */

const DEV_API = 'https://dev.api.ampersandbrands.com';

function resolveApiBase(): string {
  const override = import.meta.env.VITE_API_BASE;
  if (typeof override === 'string') return override;
  return DEV_API;
}

export const API_BASE = resolveApiBase();
